import { stringValue } from "./sourceRows"
import type { InboxContactOrderSourceRow } from "./sourceRows"
import type { InboxContactOrderPayload } from "./payload"

export const payloadActionCaseId = (payload: InboxContactOrderPayload) =>
  stringValue(payload.action_case_id)

export const sourceForPayload = ({
  payload,
  sourceByActionCaseId,
}: {
  payload: InboxContactOrderPayload
  sourceByActionCaseId: Record<string, InboxContactOrderSourceRow>
}): InboxContactOrderSourceRow | null => {
  const actionCaseId = payloadActionCaseId(payload)

  return actionCaseId ? (sourceByActionCaseId[actionCaseId] ?? null) : null
}
